// @flow
import Auth0Lock from 'auth0-lock'

export class Auth {

  auth: Auth0Lock

  constructor() {
    // --- Auth Lock Login ---
    this.auth = new Auth0Lock('dQEcuM5Tj5Wf8EuR9e0wfgmRgHB4YNpt', 'login.optionsedu.com', {
      languageDictionary: {
        title: 'OptionsEDU'
      },
      theme: {
        logo: require('../../static/images/logo.png'),
        primaryColor: '#0076BF'
      },
      autoclose: true,
      closable: true,
      auth: {
        redirectUrl: String(process.env.REACT_APP_ROOT),
        responseType: 'token id_token',
        audience: 'http://api.optionsedu.com',
        params: {
          scope: 'openid profile email'
        },
        sso: false
      },
      configurationBaseUrl: 'https://cdn.auth0.com'
    })
    this.scheduleRenewal();
  }


  onLoad = (): Promise<string> => {
    return new Promise(resolve => {
      
      this.auth.on('hash_parsed', (authResult: Object) => {

        if (Auth.isAuthenticated()) return resolve('loggedIn')
        else if (!!authResult && !!authResult.idTokenPayload) {
          const {
            accessToken,
            idToken,
            scope,
            idTokenPayload: {
              name,
              sub,
              nickname
            }
          } = authResult
          // validate for beta scopes
          // Set the time that the Access Token will expire at
          const expiresAt: string = JSON.stringify((3 * 86400000) + new Date().getTime())

          localStorage.setItem('user_name', name)
          localStorage.setItem('user_nickname', nickname)
          localStorage.setItem('user_uid', sub)
          localStorage.setItem('expires_at', expiresAt)
          localStorage.setItem('access_token', accessToken)
          localStorage.setItem('id_token', idToken)
          localStorage.setItem('permissions', scope)

          return resolve('authenticated')
          
        } else {

          // save attempted URL
          const url: string = window.location.href.toString()
          const base: string = String(process.env.REACT_APP_ROOT)
          const redirect: string = `/${url.split(base).pop()}`
          localStorage.setItem('redirect', redirect)

          // show auth lock
          //this.showLock()
          return resolve('')
        }
      })
    })
  }
  
  renewToken() {
    this.auth.checkSession({}, (err, result) => {
        if (err) {
          console.log(err);
        } else {
          this.setSession(result);
        }
      }
    );
  }
  
  setSession(authResult) {
    // Set the time that the Access Token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    
    // schedule a token renewal
    this.scheduleRenewal();
    
  }
  
  scheduleRenewal() {

    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    const delay = expiresAt - Date.now();
    if (delay > 0) {
      this.tokenRenewalTimeout = setTimeout(() => {
        this.renewToken();
      }, delay);
    }
  }

  // display login lock
  showLock = () => this.auth.show()

  // on log out
  logout = () => {

    // log out AuthLock & return to login
    this.auth.logout({
      returnTo: String(process.env.REACT_APP_ROOT)
    })
    clearTimeout(this.tokenRenewalTimeout);
  }

  // check auth
  static isAuthenticated = (): boolean => {

    // Check whether the current time is past the Access Token's expiry time
    const expiresAt: number = Number(JSON.parse(window.localStorage.getItem('expires_at')))
    return new Date().getTime() < expiresAt
  }
}



// WEBPACK FOOTER //
// ./src/services/auth/index.js